var t={item:"rl2_breadthofentitylists-module_item_uuu-v"};export{t as default};
